import Header from "../../Components/Header";
import Footer from "../HomePage/Footer";

const Policy: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Header />

      <div className="max-w-4xl mx-auto p-6 text-gray-800">
        <h1 className="text-3xl font-bold mb-4">Política de Privacidad</h1>
        <p className="mb-4">
          En <strong>MyBot Service</strong> respetamos y protegemos la
          privacidad de tus datos. Esta política describe cómo recopilamos,
          usamos y protegemos la información de los usuarios que interactúan con
          nuestros servicios a través de la API de WhatsApp.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">
          1. Información que recopilamos
        </h2>
        <ul className="list-disc list-inside mb-4">
          <li>Número de teléfono de WhatsApp del usuario.</li>
          <li>Mensajes enviados y recibidos a través de la API.</li>
          <li>Datos técnicos como dirección IP, tipo de dispositivo y registros de uso.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-6 mb-2">
          2. Uso de la información
        </h2>
        <p className="mb-4">La información recopilada se utiliza para:</p>
        <ul className="list-disc list-inside mb-4">
          <li>Procesar y responder mensajes a través de la API de WhatsApp.</li>
          <li>Personalizar y mejorar la experiencia del usuario.</li>
          <li>Monitorear y optimizar el rendimiento del servicio.</li>
          <li>Cumplir con requisitos legales y regulatorios.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-6 mb-2">
          3. Compartición de datos
        </h2>
        <p className="mb-4">
          No vendemos, alquilamos ni compartimos tu información personal con
          terceros, salvo en los siguientes casos:
        </p>
        <ul className="list-disc list-inside mb-4">
          <li>
            Con proveedores de servicios que operan en nuestro nombre (por
            ejemplo, hosting o almacenamiento en la nube).
          </li>
          <li>
            Cuando sea requerido por ley, orden judicial o autoridad competente.
          </li>
          <li>
            Para proteger los derechos, propiedad o seguridad de nuestros
            usuarios y de MyBot Service.
          </li>
        </ul>

        <h2 className="text-xl font-semibold mt-6 mb-2">
          4. Seguridad de los datos
        </h2>
        <p className="mb-4">
          Implementamos medidas técnicas, administrativas y físicas para
          proteger tu información contra accesos no autorizados, pérdida, uso
          indebido o alteración.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">
          5. Conservación de datos
        </h2>
        <p className="mb-4">
          Conservaremos tu información únicamente durante el tiempo necesario
          para cumplir con los fines establecidos en esta política, salvo que la
          ley requiera o permita un período de conservación más largo.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">
          6. Derechos del usuario
        </h2>
        <p className="mb-4">
          Tienes derecho a acceder, rectificar, eliminar y oponerte al
          tratamiento de tus datos, así como a solicitar la portabilidad de los
          mismos. Para ejercer estos derechos, puedes contactarnos en:
        </p>
        <p className="mb-4">
          <a
            href="mailto:mybotserviceco@gmail.com"
            className="text-blue-600 underline"
          >
            mybotserviceco@gmail.com
          </a>
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">
          7. Cambios en esta política
        </h2>
        <p className="mb-4">
          Nos reservamos el derecho de actualizar esta política en cualquier
          momento. Publicaremos la nueva versión en nuestro sitio web indicando
          la fecha de última actualización.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">8. Contacto</h2>
        <p className="mb-4">
          Si tienes preguntas sobre esta política o sobre el tratamiento de tus
          datos, puedes escribirnos al correo:
        </p>
        <p className="mb-4">
          <a
            href="mailto:mybotserviceco@gmail.com"
            className="text-blue-600 underline"
          >
            mybotserviceco@gmail.com
          </a>
        </p>

        <p className="text-sm text-gray-500 mt-8">
          Última actualización: {new Date().toLocaleDateString()}
        </p>
      </div>

      <Footer />
    </div>
  );
};

export default Policy;
